import { ActionType } from "typesafe-actions";
import * as actions from "./actions";
import { getHallRoomsSuccess } from "./actions";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  callApiDelete,
  callApiGet,
  callApiPost,
  callApiPut,
} from "../../utils/api";
import { HallRoomActionTypes } from "./types";
import { message } from "antd";

type GetHallRoomAction = ActionType<typeof actions.getHallRoom>;
type GetHallRoomByHallAction = ActionType<typeof actions.getHallRoomsByHall>;
type CreateHallRoomsAction = ActionType<typeof actions.createHallRoom>;
type UpdateHallRoomsAction = ActionType<typeof actions.updateHallRoom>;
type DeleteHallRoomAction = ActionType<typeof actions.deleteHallRoom>;

function* getHallRooms({ payload }: GetHallRoomAction) {
  try {
    const response = yield call(
      callApiGet,
      `halls/${payload.hall_id}/floors/${payload.floor_id}/rooms`
    );
    yield put(getHallRoomsSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallRoomsFailure(error.response.data));
  }
}

function* getHallRoomsByHall({ payload }: GetHallRoomByHallAction) {
  try {
    const response = yield call(callApiGet, `halls/${payload}/rooms`);
    yield put(getHallRoomsSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallRoomsFailure(error.response.data));
  }
}

function* getHallRoom({ payload }: GetHallRoomAction) {
  try {
    const response = yield call(
      callApiGet,
      `halls/${payload.hall_id}/floors/${payload.floor_id}/rooms/${payload.id}`
    );
    yield put(actions.getHallRoomSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallRoomFailure(error.response.data));
  }
}

function* createHallRoom({ payload }: CreateHallRoomsAction) {
  try {
    const response = yield call(
      callApiPost,
      `halls/${payload.hall_id}/floors/${payload.floor_id}/rooms`,
      payload
    );
    yield put(actions.createHallRoomSuccess(response.data));
    message.success("Room created successfully");
  } catch (error: any) {
    yield put(actions.createHallRoomFailure(error.response.data));
    message.error("Failed to create room. Please try again");
  }
}

function* updateHallRoom({ payload }: UpdateHallRoomsAction) {
  try {
    const response = yield call(
      callApiPut,
      `halls/${payload.hall_id}/floors/${payload.floor_id}/rooms`,
      payload,
      payload.id
    );
    yield put(actions.updateHallRoomSuccess(response.data));
    message.success("Room updated successfully");
  } catch (error: any) {
    yield put(actions.updateHallRoomFailure(error.response.data));
    message.error("Failed to update room. Please try again");
  }
}

function* deleteHallRoom({ payload }: DeleteHallRoomAction) {
  try {
    const response = yield call(
      callApiDelete,
      `halls/${payload.hall_id}/floors/${payload.floor_id}/rooms`,
      payload.id
    );
    yield put(actions.deleteHallRoomSuccess(response.data));
    message.success("Room deleted successfully");
  } catch (error: any) {
    yield put(actions.deleteHallRoomFailure(error.response.data));
    message.error("Failed to delete room. Please try again");
  }
}

function* watchGetHallRooms() {
  yield takeEvery(HallRoomActionTypes.FETCH_ROOMS_REQUEST, getHallRooms);
}

function* watchGetHallRoomsByHall() {
  yield takeEvery(
    HallRoomActionTypes.FETCH_ROOMS_BY_HALL_REQUEST,
    getHallRoomsByHall
  );
}

function* watchCreateHallRoom() {
  yield takeEvery(HallRoomActionTypes.CREATE_ROOM_REQUEST, createHallRoom);
}

function* watchUpdateHallRoom() {
  yield takeEvery(HallRoomActionTypes.UPDATE_ROOM_REQUEST, updateHallRoom);
}

function* watchGetHallRoom() {
  yield takeEvery(HallRoomActionTypes.FETCH_ROOM_REQUEST, getHallRoom);
}

function* watchDeleteHallRoom() {
  yield takeEvery(HallRoomActionTypes.DELETE_ROOM_REQUEST, deleteHallRoom);
}

export function* HallRoomsSaga() {
  yield all([
    fork(watchGetHallRooms),
    fork(watchGetHallRoomsByHall),
    fork(watchCreateHallRoom),
    fork(watchUpdateHallRoom),
    fork(watchGetHallRoom),
    fork(watchDeleteHallRoom),
  ]);
}
